import Avatar from "atoms/avatars/avatar";
import React from "react";
import { PropsWithChildren } from "react";
import { t } from "utilities/localization-utils";

interface LockedForEditingWrapperProps extends PropsWithChildren {
    isLocked: boolean;
    firstName?: string;
    lastName?: string;
    autoPosition?: boolean;
}
const CSS_CLASS_NAME = "c-locked-for-editing-wrapper";
const LockedForEditingWrapper = ({
    firstName,
    lastName,
    isLocked,
    children,
    autoPosition = true,
}: LockedForEditingWrapperProps) => {
    const displayName =
        firstName && lastName
            ? `${firstName} ${lastName?.slice(0, 1)}.`
            : undefined;
    return isLocked ? (
        <div className={CSS_CLASS_NAME}>
            <div
                className={`${CSS_CLASS_NAME}__block`}
                onKeyDownCapture={(e) => e.stopPropagation()}
                onClickCapture={(e) => e.stopPropagation()}>
                {children}
            </div>
            <span
                className={`${CSS_CLASS_NAME}__current-editor  ${autoPosition && "-autoPosition"}`}
                role="status">
                <span className={`${CSS_CLASS_NAME}__avatar-wrapper`}>
                    {firstName && lastName && (
                        <Avatar name={`${firstName} ${lastName}`} />
                    )}
                </span>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t("personIsCurrentlyEditing", {
                            person: displayName ?? t("someone"),
                        }),
                    }}
                />
            </span>
        </div>
    ) : (
        <>{children}</>
    );
};

export default LockedForEditingWrapper;
